import { useNavigate } from "@tanstack/react-router";
import { ReactComponent as ActiveIcon } from "../../assets/img/live/active-icon.svg";
import { ReactComponent as ActiveMesh } from "../../assets/img/live/active-mesh.svg";
import { ReactComponent as InactiveIcon } from "../../assets/img/live/inactive-icon.svg";
import { ReactComponent as InactiveMesh } from "../../assets/img/live/inactive-mesh.svg";
import { Card, CardTitle } from "components/elements";
import { useUserTimezone } from "hooks/useUserTimezone";
import { trpc } from "lib/trpc";

export const Live = () => {
    const meetingList = trpc.zoom.getMeetingsList.useQuery().data?.meetings;
    const navigate = useNavigate();
    const timeZone = useUserTimezone();

    return (
        <div className="mx-auto w-full justify-center">
            <Card>
                <div>
                    <div className="mb-4 justify-self-start font-sans text-[28px] font-semibold tracking-normal text-[#424242]">
                        Live
                    </div>
                    {!meetingList?.length ? (
                        <div className="relative flex w-full max-w-full items-center rounded-2xl">
                            <InactiveMesh
                                className="absolute inset-0 h-full w-full rounded-2xl"
                                preserveAspectRatio="none"
                            />
                            <div className="relative z-10 w-full max-w-screen-md px-8 py-8">
                                <InactiveIcon className="-ml-2 h-20 w-20" />
                                <div className="text-xl font-semibold text-white">
                                    You have no webinars at the moment.
                                </div>
                                <p className="text-base text-white">
                                    We will notify you about upcoming events.
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-6">
                            {meetingList.map((meeting) => (
                                <div key={meeting.meetingId}>
                                    <div className="relative flex w-full max-w-full items-center rounded-2xl">
                                        <ActiveMesh
                                            className="absolute inset-0 h-full w-full rounded-2xl"
                                            preserveAspectRatio="none"
                                        />
                                        <div className="relative z-10 w-full max-w-screen-md px-8 py-8">
                                            <ActiveIcon className="-ml-2 h-20 w-20" />
                                            <div className="text-xl font-semibold text-white">
                                                {meeting.title || "A webinar is starting!"}
                                                <span className="text-base">
                                                    {" "}
                                                    -{" "}
                                                    {new Intl.DateTimeFormat("en-US", {
                                                        month: "short",
                                                        day: "2-digit",
                                                        year: "numeric",
                                                        hour: "numeric",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                        timeZone,
                                                    }).format(new Date(meeting.startTime))}
                                                </span>
                                            </div>
                                            <div className="flex w-full flex-row items-center gap-10">
                                                <div className="text-base text-white">
                                                    Join the webinar now.
                                                </div>
                                                <button
                                                    className="rounded-md bg-[#f7fbfc] px-4 py-1 text-[#424242]"
                                                    onClick={() =>
                                                        navigate({
                                                            to: "/events/$id",
                                                            params: { id: `${meeting.meetingId}` },
                                                        })
                                                    }
                                                >
                                                    Access
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </Card>
        </div>
    );
};
